// extracted by mini-css-extract-plugin
export default {"button":"Button_button__gwA0P","new-style":"Button_new-style__70fUo","delete-style":"Button_delete-style__VB2d6","edit":"Button_edit__BxPvD","action":"Button_action__lFHOZ"};